<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">

    <side-bar
      :background-color="sidebarBackground"
      short-title="BXI"
      title="BXI"
    >

     <template v-if="developerMode==true" slot="links" >
        <sidebar-item
          :link="{
            name: 'Developer Dashboard',
            icon: 'ni ni-tv-2 text-black',
            path: '/developer_dashboard'
          }"
        />
      </template>
      <!-- <template  v-else-if="!isRippleAdmin && developerMode == false" slot="links" >
        <sidebar-item
          :link="{
            name: 'Dashboard',
            icon: 'ni ni-tv-2 text-black',
            path: '/dashboard'
          }"
        />
      </template>
      <template v-else slot="links" >
        <sidebar-item
          :link="{
            name: 'Admin Dashboard',
            icon: 'ni ni-tv-2 text-green',
            path: '/dashboard'
          }"
        />
      </template> -->
    </side-bar>

    <div class="main-content" :data="sidebarBackground">

      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in" >
          <!-- your content here -->
          <router-view :key="componentKey"></router-view>
          <!-- <router-view></router-view> -->
        </fade-transition>
        <div>
      <!-- <b-button v-b-modal.modal-1 class="btn-sm btn default">Launch demo modal</b-button> -->
      <!-- <button v-b-modal.modal-1 type="button" class="btn btn-sm btn-primary" data-toggle="modal" data-target="#exampleModal">
       Launch demo modal
      </button> -->

      <b-modal id="modal-1" ref="modal-1">
        <template slot="modal-header">
          CHANGE PASSWORD
        </template>

        <template slot="default">
            <div class="col-md-12 p-4 card-body">
              <div class="row">
                <div class="col-lg-12">
                  <base-input label="Current Password">
                    <div class="form-group input-group"><!---->
                      <input aria-describedby="addon-right addon-left" placeholder="Password" data-testid="login-input-password" id="login-input-password" :type="defaultPasswordTypeOldPassword" class="form-control" v-model="oldPassword"><!----><!---->
                      <div class="input-group-prepend">
                        <a class="input-group-text" @click="changePasswordTypeOld">
                          <span v-if="defaultPasswordTypeOldPassword == 'password'" style="color: #adb5bd;"><i class="fas fa-eye"></i></span>
                          <span v-else style="color: #adb5bd;"><i class="fa fa-eye-slash"></i></span>
                        </a>
                      </div>
                    </div>
                  </base-input>
                  <!-- <base-input type="password" label="Current Password" input-classes="form-control" v-model="oldPassword"/> -->
                </div>
                <div class="col-lg-12">
                  <base-input  label="New Password">
                    <div class="form-group input-group"><!---->
                      <input aria-describedby="addon-right addon-left" placeholder="New Password" data-testid="login-input-password" id="login-input-password" :type="defaultPasswordTypeNewPassword" class="form-control" v-model="newPassword"><!----><!---->
                      <div class="input-group-prepend">
                        <a class="input-group-text" @click="changePasswordType">
                          <span v-if="defaultPasswordTypeNewPassword == 'password'" style="color: #adb5bd;"><i class="fas fa-eye"></i></span>
                          <span v-else style="color: #adb5bd;"><i class="fa fa-eye-slash"></i></span>
                        </a>
                      </div>
                    </div>
                  </base-input>
                    <!-- <base-input  type="password" label="New Password" input-classes="form-control" v-model="newPassword"/> -->
                  <b-form-text v-if="userPasswordFormatStrict"  id="password-help" v-html="passwordValidationLabel"></b-form-text>
                </div>
                <div class="col-lg-12">
                  <base-input  type="password" label="Password Confirmation">
                    <div class="form-group input-group"><!---->
                      <input aria-describedby="addon-right addon-left" placeholder="Password Confirmation" data-testid="login-input-password" id="login-input-password" :type="defaultPasswordTypeNewPasswordConfirmation" class="form-control" v-model="newPasswordConfirmation"><!----><!---->
                      <div class="input-group-prepend">
                        <a class="input-group-text" @click="changePasswordType1">
                          <span v-if="defaultPasswordTypeNewPasswordConfirmation == 'password'" style="color: #adb5bd;"><i class="fas fa-eye"></i></span>
                          <span v-else style="color: #adb5bd;"><i class="fa fa-eye-slash"></i></span>
                        </a>
                      </div>
                    </div>
                  </base-input>
                  <!-- <base-input  type="password" label="Password Confirmation" input-classes="form-control" v-model="newPasswordConfirmation"/> -->
                </div>
              </div>
            </div>
        </template>

        <div slot="modal-footer" class="w-50">
          <b-button variant="danger" size="sm" class="float-right" @click.prevent="changePassword"> Change Password</b-button>
        </div>
      </b-modal>
      <div style="position: absolute; z-index: 1040;"  v-if="isRequireChangePw">
        <div class="modal fade d-block show"> 
          <div class="modal-dialog modal-md">
            <div role="document" id="modal-1___BV_modal_content_" aria-labelledby="modal-1___BV_modal_header_" aria-describedby="modal-1___BV_modal_body_" class="modal-content">
              <header id="modal-1___BV_modal_header_" class="modal-header">
                CHANGE PASSWORD
              </header>
              <div id="modal-1___BV_modal_body_" class="modal-body">
                <div class="col-md-12 p-4 card-body">
                  <div class="row">
                    <div class="col-lg-12">
                      <base-input label="Current Password">
                        <div class="form-group input-group"><!---->
                          <input aria-describedby="addon-right addon-left" placeholder="Password" data-testid="login-input-password" id="login-input-password" :type="defaultPasswordTypeOldPassword" class="form-control" v-model="oldPassword"><!----><!---->
                          <div class="input-group-prepend">
                            <a class="input-group-text" @click="changePasswordTypeOld">
                              <span v-if="defaultPasswordTypeOldPassword == 'password'" style="color: #adb5bd;"><i class="fas fa-eye"></i></span>
                              <span v-else style="color: #adb5bd;"><i class="fa fa-eye-slash"></i></span>
                            </a>
                          </div>
                        </div>
                      </base-input>
                      <!-- <base-input type="password" label="Current Password" input-classes="form-control" v-model="oldPassword"/> -->
                    </div>
                    <div class="col-lg-12">
                      <base-input  label="New Password">
                        <div class="form-group input-group"><!---->
                          <input aria-describedby="addon-right addon-left" placeholder="New Password" data-testid="login-input-password" id="login-input-password" :type="defaultPasswordTypeNewPassword" class="form-control" v-model="newPassword"><!----><!---->
                          <div class="input-group-prepend">
                            <a class="input-group-text" @click="changePasswordType">
                              <span v-if="defaultPasswordTypeNewPassword == 'password'" style="color: #adb5bd;"><i class="fas fa-eye"></i></span>
                              <span v-else style="color: #adb5bd;"><i class="fa fa-eye-slash"></i></span>
                            </a>
                          </div>
                        </div>
                      </base-input>
                        <!-- <base-input  type="password" label="New Password" input-classes="form-control" v-model="newPassword"/> -->
                      <b-form-text v-if="userPasswordFormatStrict"  id="password-help" v-html="passwordValidationLabel"></b-form-text>
                    </div>
                    <div class="col-lg-12">
                      <base-input  type="password" label="Password Confirmation">
                        <div class="form-group input-group"><!---->
                          <input aria-describedby="addon-right addon-left" placeholder="Password Confirmation" data-testid="login-input-password" id="login-input-password" :type="defaultPasswordTypeNewPasswordConfirmation" class="form-control" v-model="newPasswordConfirmation"><!----><!---->
                          <div class="input-group-prepend">
                            <a class="input-group-text" @click="changePasswordType1">
                              <span v-if="defaultPasswordTypeNewPasswordConfirmation == 'password'" style="color: #adb5bd;"><i class="fas fa-eye"></i></span>
                              <span v-else style="color: #adb5bd;"><i class="fa fa-eye-slash"></i></span>
                            </a>
                          </div>
                        </div>
                      </base-input>
                      <!-- <base-input  type="password" label="Password Confirmation" input-classes="form-control" v-model="newPasswordConfirmation"/> -->
                    </div>
                  </div>
                </div>
              </div>
              <footer class="modal-footer">
                <b-button variant="danger" size="sm" class="float-right" @click.prevent="changePassword"> Change Password</b-button>
              </footer>
            </div>
          </div>
        </div>
      </div>
      <b-modal id="modal-2" ref="modal-2">
          <template slot="modal-header">
            SERVER SETTINGS
          </template>

          <template slot="default">
            <div class="col-md-12 p-4 card-body">
              <base-input label="Server Type">
                  <select class="form-control col-md-12" v-model="serverType2">
                      <option value="ho">Head Office</option>
                      <option value="branch">Branch</option>
                  </select>
              </base-input>

              <div v-if="serverType2 == 'branch'">
                <base-input v-model="HoAddress" label="Head Office Address" placeholder="" input-classes="form-control col-md-12" required/>
                <base-input v-model="HoUser" label="HO User" placeholder="" input-classes="form-control col-md-12" required/>
                <base-input v-model="HoPassword" type="password" label="HO Password" placeholder="" input-classes="form-control col-md-12" required/>
                <base-input v-model="siteCode" label="Site Code" placeholder="" input-classes="form-control col-md-12" required/>
              </div>

              <base-input label="Upload Logo (PNG file only)">
                <a-upload 
                  action="" 
                  :customRequest="uploadAccountLogo" 
                  :remove="handleLogoRemove" 
                  listType="picture-card" 
                  :fileList="fileList" 
                  @preview="handlePreview" 
                  @change="handleChange" 
                  :headers="authHeaders" 
                  accept=".png">
                    <div v-if="fileList.length < 1 && imageLoaded == true"> +
                      <div class="ant-upload-text">PNG only</div>
                    </div>
                </a-upload>
                <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel" style="z-index: 999999 !important;">
                    <img alt="example" style="width: 100%" :src="previewImage" />
                </a-modal>
              </base-input>
            </div>
          </template>

        <div slot="modal-footer" class="w-50">
          <b-button variant="primary" size="sm" class="float-right" @click="saveServerSetting"> Save Configuration</b-button>
        </div>
      </b-modal>

      <b-modal id="modal-3" ref="modal-3">
         <template slot="modal-header">
           SWITCH BRANCH
         </template>
          <template slot="default">
            <div class="col-md-12 p-4 card-body">
              <form>
                  <base-input label="Current Site">
                      <a-select
                          show-search
                          style="width: 100%"
                          placeholder="Please select"
                          optionFilterProp="children"
                          v-model="selectedSiteId">
                          <a-select-option v-for="site in validSites" :key="site.id" :value="site.id">{{site.name}}<template v-if="site.id == actualDefaultSiteId"> <span class="ml-1"><i>(default site)</i></span></template></a-select-option>
                      </a-select>
                  </base-input>
              </form>
            </div>
          </template>
        <div slot="modal-footer" class="w-50">
          <b-button variant="primary" size="sm" class="float-right" @click="switchBranch" > Switch Branch</b-button>
        </div>
      </b-modal>

      <b-modal id="modal-4" ref="modal-4" class="modal-lg">
         <template slot="modal-header">
           PRIVACY SETTINGS
         </template>
          <template slot="default">
            <div v-if="ownerAccount" class="card-body">

                    <!-- :file-list="webWaveletTextFiles"
                       @change="handleChangeWebText"
                       :remove="handleRemoveWebText"
                       :before-upload="beforeUploadWebText"
                       :disabled='!webUploadChecked || this.webWaveletId > 0' -->
                   <h6 class="heading-small text-muted">Terms and Conditions</h6>
                   <small>These are legal agreements between a service provider and a person who wants to use that service. Your customers must agree to abide by the terms of service in order to use the offered service</small>
                   <br/><br/>

                   <a-upload accept=".pdf"
                       :file-list="termsFiles"
                       @change="handleFileChange"
                       :remove="handleFileRemove"
                       :before-upload="beforeFileUpload"
                   >
                       <a-button> <a-icon type="upload" /> Click to Upload </a-button>
                   </a-upload>
                   <!-- <hr/> -->
                   <br/><br/>

                   <h6 class="heading-small text-muted">Privacy Policy</h6>
                   <small>A privacy policy is a statement or a legal document that discloses some or all of the ways a party gathers, uses, discloses, and manages a customer or client's data.</small>
                   <br/><br/>
                   <a-upload accept=".pdf"
                       :file-list="privacyFiles"
                       @change="handleFileChange2"
                       :remove="handleFileRemove2"
                       :before-upload="beforeFileUpload2"
                   >
                       <a-button> <a-icon type="upload" /> Click to Upload </a-button>
                   </a-upload>

            </div>
            <div v-else>
              <h6 class="heading-small text-muted">Terms and Conditions</h6>
                   <small>These are legal agreements between a service provider and a person who wants to use that service. Your customers must agree to abide by the terms of service in order to use the offered service</small>
                   <br/><br/>
                   <button class="btn btn-outline-info" @click="download('tac')">Download</button>

                   <!-- <hr/> -->
                   <br/><br/>

                   <h6 class="heading-small text-muted">Privacy Policy</h6>
                   <small>A privacy policy is a statement or a legal document that discloses some or all of the ways a party gathers, uses, discloses, and manages a customer or client's data.</small>
                   <br/><br/>
                   <button class="btn btn-outline-info" @click="download('priv')">Download</button>

            </div>
          </template>
        <div slot="modal-footer" class="w-50">
          <b-button v-if="ownerAccount" variant="success" size="sm" class="float-right" @click="uploadDpcDocs"> Save </b-button>
        </div>
      </b-modal>

      <b-modal id="modal-login-history" ref="modal-login-history" size="md">
        <template slot="modal-header">
          Login History
        </template>
        <template slot="default">
            <div class="col-md-18 p-2 card-body">
              <b-list-group>
                <b-list-group-item v-for="login_history in loginHistory" :key='login_history.id'>
                      <h4 class="mb-1">{{login_history.date}}</h4>
                      <small>{{login_history.date_to_words}}</small>
                </b-list-group-item>
              </b-list-group>
            </div>
        </template>
        <template #modal-footer="{ close }" class="w-50">
            <b-button  variant="warning" size="sm" class="float-right" @click="close()"> Close </b-button>
        </template>
      </b-modal>

      <b-modal id="modal-reminder-settings" ref="modal-reminder-settings" size="md">
        <template slot="modal-header">
          Reminder Settings
        </template>
        <a-spin :spinning="spinner" tip="Loading...">
          <template slot="default">
              <div class="col-md-18 p-2 card-body">
                  <base-checkbox class="mb-3" v-for="alerts in accountAlerts" :value="alerts" :key="alerts.code" v-model="alerts.value">
                    {{ alerts.name }}
                  </base-checkbox>
              </div>
          </template>
        </a-spin>
        <template #modal-footer="{ close }" class="w-50">
          <b-button  variant="success" size="sm" class="float-right" @click="saveReminders()"> Save </b-button>
          <b-button  variant="warning" size="sm" class="float-right" @click="close()"> Cancel </b-button>
        </template>
      </b-modal>
    </div>

        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>

<script>
  import HTTPRequest from '../controllers/httpRequest.js'
  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import { FadeTransition } from 'vue2-transitions';
  import { mapState, mapActions } from 'vuex'
  import secureStorage from '../controllers/secureStorage.js'
  import axios from "axios";
  import moment from 'moment'
  import modal from 'ant-design-vue/lib/modal';
  import { setEnabledCategories, isPathPermitted, uploadToS3, objectToFormData } from '../utilities.js'
  import ValidateField from '../components/validateFormUtils'

  export default {
    data() {
      return {
        checkedUserAlerts: [],
        spinner: false,
        componentKey: 0,
        s3_file: secureStorage.getItem("account_logo"),
        ownerAccount: secureStorage.getItem("isAccountOwner"),
        sidebarBackground: 'vue', //vue|blue|orange|green|red|primary,
        serverType2: "",
        selectedSiteId: secureStorage.getItem("defaultSiteId"),
        isRippleAdmin: secureStorage.getItem("isRippleAdmin"),
        developerMode: secureStorage.getItem("developerMode"),
        HoAddress: "",
        HoUser: "",
        HoPassword: "",
        siteCode: "",
        newPassword: null,
        newPasswordConfirmation: null,
        oldPassword: null,
        developerMode: secureStorage.getItem("developerMode"),
        termsFiles: [],
        privacyFiles: [],
        accountCredentials: {},
        accountAlerts: [],
        userAlerts: {},
        alerts: {},
        // UPLOADER
        previewVisible: false,
        errors: [],
        previewImage: '',
        fileList: [],
        imageLoaded: true,
        loginHistory: [],
        authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
        userPasswordFormatStrict: false,
        passwordValidationLabel:"",
        passwordformatValidation:{
            minPasswordLength:6,
            passwordReqOneUppercase:false,
            passwordReqOneLowercase:false,
            passwordReqOneNumber:false,
            passwordReqOneSpecialChar:false,
        },
        onPasswordExpiration:false,
        defaultPasswordTypeNewPasswordConfirmation:"password",
        defaultPasswordTypeNewPassword:"password",
        defaultPasswordTypeOldPassword:"password",
        isRequireChangePw:secureStorage.getItem('isRequireChangePw'),
        actualDefaultSiteId: null
      };
    },
    components: {
      DashboardNavbar,
      ContentFooter,
      FadeTransition
    },
    beforeRouteEnter: async (to, from, next) => {
      await setEnabledCategories();
      try {
        if (isPathPermitted(to.fullPath)) {
          next();
        } else {
          next('dashboard');
        }
      } catch (error) {
      }
    },
    beforeRouteUpdate (to, from, next) {
      try {
        if (isPathPermitted(to.fullPath)) {
          next();
        } else {
          next('dashboard');
        }
      } catch (error) {
      }
    },
    mounted: async function(){
      // this.setEnabledCategories();
      this.forceRerender()
      if (this.developerMode != true) {
        var serverSettings = await HTTPRequest.getRequest(this.endPoint + 'settings?code=server_type', null)
        this.updateServerType(serverSettings[0]["value"])
        // this.serverType = serverSettings[0]["value"]
        this.serverType2 = serverSettings[0]["value"]
        if(this.serverType == 'branch'){
          var hoAddress = await HTTPRequest.getRequest(this.endPoint + 'settings?code=ho_address', null)
          this.HoAddress = hoAddress[0]["value"]
          var siteCode = await HTTPRequest.getRequest(this.endPoint + 'settings?code=site_code', null)
          this.siteCode = siteCode[0]["value"]
          var  HoUser = await HTTPRequest.getRequest(this.endPoint + 'settings?code=ho_user', null)
          this.HoUser = HoUser[0]["value"]
          var HoPassword = await HTTPRequest.getRequest(this.endPoint + 'settings?code=ho_password', null)
          this.HoPassword = HoPassword[0]["value"]
        }

        let logoSettings = await HTTPRequest.getRequest(this.endPoint + 'settings?code=account_logo', null)
        if (logoSettings.length > 0 && logoSettings[0]["value"] != null && logoSettings[0]["value"] != '') {
          // let logo_img = logoSettings[0]["value"]

          this.fileList = [{
            uid: logoSettings[0]['id'],
            name: logoSettings[0]["name"],
            status: 'done',
            // url: this.publicUrl + 'account_logos/' + logo_img
            url: logoSettings[0]["value"]
          }]
        } else {
          this.fileList = []
        }
      }

      this.$root.$on('bv::modal::show',async (bvEvent, modalId) => {
        // console.log('Modal is about to be shown', bvEvent, modalId)
        if(modalId == 'modal-login-history'){
          let backendActivities = await HTTPRequest.getRequest(this.endPoint + 'backend_activities/get_user_backend_activity?limit=5&trans_code=LOGIN')
          backendActivities.forEach((el) => {
            el.date_to_words = moment(el.date).fromNow();
            el.date = moment(el.date)
          })

          this.loginHistory = backendActivities
        } else if(modalId == 'modal-reminder-settings'){
          this.spinner = true;
          var credentials = await this.getCachedAccountSettingsByCode()
          var res_alerts = await HTTPRequest.getRequest(this.endPoint + 'settings/get_alerts' , null)
          var user_alerts = await HTTPRequest.getRequest(this.endPoint + 'settings/get_user_alerts?userId=' + secureStorage.getItem("userId") + '&defaultSiteId=' + secureStorage.getItem("defaultSiteId") + '', null)

          try {
            this.accountCredentials = JSON.parse(credentials.value)
            this.accountAlerts = []
            this.userAlerts = {}
            if(user_alerts.length > 0){
              this.userAlerts = JSON.parse(user_alerts[0].system_alert_id)
            }
            
            res_alerts['alerts'].forEach((el) => {
              if (this.accountCredentials.hasOwnProperty(el['code']) && this.accountCredentials[el['code']] == true) {
                var alert_value = (this.userAlerts.hasOwnProperty(el['code']) && this.userAlerts[el['code']] == true) ? true : false;
                this.accountAlerts.push({ 
                  "code" : el['code'],
                  "name" : el['name'],
                  "value": alert_value
                })
              }
            })
          } catch (error) {}
          this.spinner = false;
        } else if(modalId == 'modal-3') {
          try {
            var user = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId"), null)
            this.actualDefaultSiteId = user.site_id
          } catch(e) {}
        }
      })
      this.getAccountSettings();
    },
    computed: {
      ...mapState(['endPoint', 'serverType',
                   'validSites', 'publicUrl',
                   'enabledCategories']),
    },
    watch:{
      newPassword : function(){
        if(this.userPasswordFormatStrict){
          this.passwordValidationLabel = ""
          if (this.newPassword.length < this.passwordformatValidation.minPasswordLength) {
            this.passwordValidationLabel += `Your password needs a minimum of ${this.passwordformatValidation.minPasswordLength} characters. <br>`;
          }
          if (this.passwordformatValidation.passwordReqOneLowercase && this.newPassword.search(/[a-z]/) == -1) {
            this.passwordValidationLabel += "Your password needs at least one lower case letter. <br>";
          }
          if (this.passwordformatValidation.passwordReqOneUppercase && this.newPassword.search(/[A-Z]/) == -1) {
            this.passwordValidationLabel += "Your password needs at least one upper case letter. <br>";
          }
          if (this.passwordformatValidation.passwordReqOneNumber && this.newPassword.search (/[0-9]/) == -1) {
            this.passwordValidationLabel += "Your password needs a number.<br>";
          }
          if (this.passwordformatValidation.passwordReqOneSpecialChar && this.newPassword.search (/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/) == -1){
            this.passwordValidationLabel += "Your password needs at least one special character.<br>";
          }
        }
      }
    },
    methods: {
      ...mapActions(['updateServerType', 'updateSelectedSite',
                     'updateEnabledCategories', 'updateEnabledCategoryUrls']),
      async getCachedAccountSettingsByCode() {
        var cacheKey = `accountSettings_${secureStorage.getItem("accountId")}`
        var cachedAccountSettings = secureStorage.getItem(cacheKey)
        if (cachedAccountSettings) return cachedAccountSettings

        var credentials = await HTTPRequest.getRequest(this.endPoint + 'settings/accountSettings?field_name=code' , null)
        if (credentials) secureStorage.setItem(cacheKey, credentials)
        return credentials
      },
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      },
      changePasswordTypeOld(){
        if(this.defaultPasswordTypeOldPassword=="password"){
          this.defaultPasswordTypeOldPassword = "text"
        }else{
          this.defaultPasswordTypeOldPassword = "password"
        }
      },
      changePasswordType(){
        if(this.defaultPasswordTypeNewPassword=="password"){
          this.defaultPasswordTypeNewPassword = "text"
        }else{
          this.defaultPasswordTypeNewPassword = "password"
        }
      },
      changePasswordType1(){
        if(this.defaultPasswordTypeNewPasswordConfirmation=="password"){
          this.defaultPasswordTypeNewPasswordConfirmation = "text"
        }else{
          this.defaultPasswordTypeNewPasswordConfirmation = "password"
        }
      },
      setEnabledCategories() {
        const loggedIn = secureStorage.getItem("loggedIn");
        const developerMode = secureStorage.getItem("developerMode");
        const isRippleAdmin = secureStorage.getItem("isRippleAdmin")
        if (!loggedIn || isRippleAdmin || developerMode) { return; }

        const categoriesPromise = new Promise(async (resolve, reject) => {
          const categories = await HTTPRequest.getRequest(`${this.endPoint}system_module_categories/user_enabled_parent_categories`, null);
          resolve(categories);
        })

        categoriesPromise.then(categories => {
          const enabledCategories = categories.categories
          const enabledUrls = [];

          let parentCategories = []
          let addedParentCategories = []
          enabledCategories.map( category => {
            if (!addedParentCategories.includes(category.G)) {
              parentCategories.push({
                id: category.system_module_category_id,
                code: category.system_module_category_code,
                name: category.system_module_category_name,
              })
              addedParentCategories.push(category.system_module_category_id);
            }

            if (!enabledCategories.includes(category.endpoint)) {
              enabledUrls.push(category.endpoint)
            }
          })

          parentCategories.map( (category, indx) => {
            const raw_children = enabledCategories.filter( module => module.system_module_category_id == category.id )
            parentCategories[indx].raw_children = raw_children;
          })

          this.updateEnabledCategories(parentCategories)
          this.updateEnabledCategoryUrls(enabledUrls)
        })
      },
      async saveReminders() {
        this.spinner = true;
        var user_alert = {}
        this.accountAlerts.forEach((el) => {
          user_alert[el['code']] = el['value']
        })

        this.userAlerts = user_alert
        secureStorage.setItem("userAlerts", user_alert)
        var alertPayload = {
          user_alert: user_alert
        }
        var updateuserAlerts = await HTTPRequest.postRequest(this.endPoint + 'settings/update_user_alerts?userId='+secureStorage.getItem("userId")+'', null, alertPayload)
        this.$refs['modal-reminder-settings'].hide()
        if(updateuserAlerts){
          this.$notification['success'](
            {
                message: "Action succesful",
                description: updateuserAlerts['msg']
            }
          );
          location.reload();
        } else {
          this.$notification['error'](
            {
                message: "Action failed",
                description: updateuserAlerts['error']
            }
          );
        }

        this.spinner = false;
      },
      async switchBranch(){
        secureStorage.setItem("defaultSiteId", this.selectedSiteId)
        var selectedSite = this.validSites.find(x => x.id === this.selectedSiteId)
        secureStorage.setItem("defaultSiteName", selectedSite.name)
        secureStorage.setItem("defaultSiteCode", selectedSite.code)
        secureStorage.setItem("defaultSiteSBU", selectedSite.site_sbu)
        this.updateSelectedSite(selectedSite.name)
        var site = await HTTPRequest.postRequest(this.endPoint + 'sites/switch_branch_ho/?id='+this.selectedSiteId, null)
        if (site.id > 0){
          secureStorage.setItem("currentSiteSiteType", site.site_type)
          secureStorage.setItem("defaultSiteConceptId", site.site_concept_id)
        }
        this.$refs['modal-3'].hide()
        location.reload();
      },
      async changePassword(){
        // var email = secureStorage.getItem("username")
        // console.log("Here")
        // var logIn = secureStorage.getItem("name")
        var userEmail = secureStorage.getItem("userCode")
        // console.log(userEmail)
        var check_password = await HTTPRequest.postRequest(this.endPoint + "/users/validate_password", null, {email: userEmail, password: this.oldPassword})
        if(check_password["error"] == undefined){
            // console.log("Okay")
            if(this.newPassword == this.newPasswordConfirmation && this.newPassword != null && this.newPasswordConfirmation != null){
              if(!this.validatePassword()){
                var passwordResetPayload = {email: userEmail, new_password: this.newPassword,user_id:secureStorage.getItem("userId")}
                if(this.onPasswordExpiration) passwordResetPayload.password_expiration = this.checkPasswordDuration()
                var change_password = await HTTPRequest.postRequest(this.endPoint + 'users/password_change_no_code', null, passwordResetPayload)
                if(change_password["error"] == undefined){
                  if(this.onPasswordExpiration) secureStorage.setItem("passwordExpiration", passwordResetPayload.password_expiration)
                  secureStorage.setItem("isRequireChangePw", false)
                  this.$notification['success']({
                    message: 'Password Change Success',
                    description: "You can now use your new password"
                  });
                  this.isRequireChangePw = secureStorage.getItem('isRequireChangePw')
                }else{
                  this.$notification['error']({
                    message: 'Password Change Failed',
                    description: change_password["error"]
                  });
                }
                this.oldPassword = null
                this.newPassword = null
                this.newPasswordConfirmation = null
              }else{
                  this.$notification['error']({
                    message: 'Password Change Failed',
                    description: this.errors
                  });
              }
            } else {
              this.$notification['error']({
               message: 'Password Change Failed',
               description: "New password does not match"
              });
            }
        }
        else{
            var errorMessage = "It seems you've entered a wrong password. Please try again."
            // console.log(errorMessage)
            this.$notification['error']({
               message: 'Password Change Failed',
               description: errorMessage
            });
        }
      },
      async saveServerSetting(){
        let is_confirm = ( secureStorage.getItem("isRippleAdmin") || secureStorage.getItem("isAccountOwner") ) ? 0 : 1;
        let confirmation = 0;
        if(is_confirm == 1) {
          confirmation = prompt("Please input admin password to change server settings");
        }
         
        if ( is_confirm == 0 || confirmation == 123456 ){
          var settingPayload = { setting: {code: "server_type", name: "Server Type", value: this.serverType2, status: 'A'}}
          // this.serverType = this.serverType2
          this.updateServerType(this.serverType2 )
          await HTTPRequest.postRequest(this.endPoint + 'settings', null, settingPayload)

          let settingLogo = { setting: {code: "account_logo", name: "Account Logo", value: ((this.s3_file == null) ? secureStorage.getItem("default_logo") : this.s3_file['path']), status: 'A'}}
          console.log(settingLogo)
          console.log(this.s3_file)
          console.log(secureStorage.getItem("default_logo"))
          await HTTPRequest.postRequest(this.endPoint + 'settings', null, settingLogo)
          secureStorage.setItem("account_logo", ((this.s3_file == null) ? secureStorage.getItem("default_logo") : this.s3_file['path']))

          if(this.serverType == 'branch'){
            // !!! ENDPOINT TO CHECK IF CAN CONNECT TO HO
            // var settingPayloadHo = { setting: {code: "ho_address", name: "HO Address", value: this.HoAddress, status: 'A'}}
            // var hoSettings = await HTTPRequest.postRequest(this.endPoint + 'settings', null, settingPayloadHo)
            settingPayload = { settings: [
                                    {code: "ho_address", name: "HO IP Address", value: this.HoAddress, status: 'A'},
                                    {code: "ho_user", name: "HO API User", value: this.HoUser, status: 'A'},
                                    {code: "ho_password", name: "HO API Password", value: this.HoPassword, status: 'A'}
                                    ]
                               }
            var hoSettings = await HTTPRequest.postRequest(this.endPoint + 'settings/mass_create?server_settings=1', null, settingPayload)
            // this.messages = updateSetting["message"]
            if(hoSettings["error"] == undefined){
              var settingPayloadHo = { setting: {code: "site_code", name: "Site Code", value: this.siteCode, status: 'A'}}
              var branchSettings = await HTTPRequest.postRequest(this.endPoint + 'settings', null, settingPayloadHo)
              if(branchSettings["error"] == undefined){
                this.$notification['success'](
                  {
                      message: "Action succesful",
                      description: "Please refresh page for changes to take effect."
                  }
                );
                this.updateServerType(this.serverType2)
                this.$refs['modal-2'].hide()
              } else {
                alert("Invalid site code")
              }
            } else {
              alert(hoSettings["error"])
            }
          } else {
            this.$notification['success'](
              {
                  message: "Action succesful",
                  description: "Please refresh page for changes to take effect."
              }
            );
            this.updateServerType(this.serverType2)
            this.$refs['modal-2'].hide()
          }
          // alert("Successfully updated server settings")
        } else {
          alert("Invalid Password")
        }
        // alert("Okay")
      },
      handleFileRemove(file) {
        const index = this.termsFiles.indexOf(file);
        const newFileList = this.termsFiles.slice();
        newFileList.splice(index, 1);
        this.termsFiles = newFileList;
      },
      beforeFileUpload(file) {
         this.termsFiles = [...this.termsFiles, file];
         return false;
      },
      async handleFileChange(file){
          var arrayLength = this.termsFiles.length - 1

          var latestUpload = this.termsFiles[arrayLength]
          if (latestUpload != undefined) {
              var fileExtension = latestUpload.name.split(".").pop()
              if(fileExtension != "pdf"){
                  this.$notification['error']({
                      message: 'Unsupported file type',
                      description: "Upload .pdf files only."
                  });
                  this.handleFileRemove(file)
              }  else {
                  console.log("Will override")
                  if(this.termsFiles.length > 1)
                      this.handleFileRemove(this.termsFiles[0])
              }
          }
      },
      handleFileRemove2(file) {
        const index = this.privacyFiles.indexOf(file);
        const newFileList = this.privacyFiles.slice();
        newFileList.splice(index, 1);
        this.privacyFiles = newFileList;
      },
      beforeFileUpload2(file) {
         this.privacyFiles = [...this.privacyFiles, file];
         return false;
      },
      async handleFileChange2(file){
          var arrayLength = this.privacyFiles.length - 1

          var latestUpload = this.privacyFiles[arrayLength]
          if (latestUpload != undefined) {
              var fileExtension = latestUpload.name.split(".").pop()
              if(fileExtension != "pdf"){
                  this.$notification['error']({
                      message: 'Unsupported file type',
                      description: "Upload .pdf files only."
                  });
                  this.handleFileRemove(file)
              }  else {
                  console.log("Will override")
                  if(this.privacyFiles.length > 1)
                      this.handleFileRemove(this.privacyFiles[0])
              }
          }
      },
      async download(type){
        var downloadFile = await axios({
             method: 'get',
             responseType: 'blob', // important
             url: this.endPoint + "/accounts/"+ secureStorage.getItem("accountId") + "/get_dpc_docs?type=" + type,
             headers: {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")}
        })
        const url = window.URL.createObjectURL(new Blob([downloadFile.data], {type: 'application/pdf'}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'dpc_document.pdf');
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        this.$notification['success']({
            message: 'Successful Download',
            description: "You have succesfully downloaded the file."
        });

        this.$refs['modal-4'].hide()

        // console.log(downloadFile.data)
            // console.log(downloadFile)

      },
      async uploadDpcDocs(){
        var bodyFormData = new FormData();
        bodyFormData.append('file', this.termsFiles[0])
        bodyFormData.append('file2', this.privacyFiles[0])
        var uploadFile = await axios({
             method: 'post',
             url: this.endPoint + "/accounts/"+ secureStorage.getItem("accountId") + "/upload_dpc_docs",
             data: bodyFormData,
             headers: {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")}
         })

         if(uploadFile.data.error == undefined){
           this.$message['success'](
             "File uploaded successfully."
           )
           this.$refs['modal-4'].hide()
         }

        // console.log(uploadFile)
      },
      handleCancel () {
          this.previewVisible = false
      },
      handlePreview (file) {
          this.previewImage = file.url || file.thumbUrl
          this.previewVisible = true
      },
      handleChange ({ fileList }) {
          this.fileList = fileList;
      },
      handleLogoRemove({ fileList }){
        this.fileList = [];
        this.s3_file = null
      },
      async uploadAccountLogo(options) {
          let {data, onSuccess, onError, file, onProgress,action} = options
          const accountName = secureStorage.getItem("accountName");
          const uploaderEndpoint = await HTTPRequest.getRequest(this.endPoint + 'settings/api_s3_uploader', null, null) || {}
          if (!uploaderEndpoint.endpoint) { return { error: 'No S3 endpoint' } }

          const accountId = secureStorage.getItem("accountId");
          const newFileName = `${moment().format('MMDDYYhhmmss')}-${accountId}-${file.name}`
          const myRenamedFile = new File([file], newFileName);

          let fileFormData = new FormData();
          fileFormData.append('file', myRenamedFile);
          
          if(file['type'] != "image/png"){
              this.$notification['error']({
                  message: 'Unsupported file type',
                  description: "Upload .png file only."
              });
              this.handleLogoRemove(file)
          }  else {
              let fileResponse;
              await axios({
                method: 'POST',
                url: uploaderEndpoint.endpoint + '?profile=accounts&account_name='+accountName,
                headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken")},
                data : fileFormData
              })
              .then(function (response) {
                fileResponse = response.data
                onSuccess(null,file)
              })
              .catch(function (error) {
                fileResponse = { error: error }
                onError('err',error)
              });
              this.s3_file =  fileResponse;
          }
      },
      validatePassword(){
        this.errors = []
        if(this.userPasswordFormatStrict == true){
            if (this.passwordformatValidation.passwordReqOneUppercase) this.errors.push(ValidateField.upperCaseCharacterRequired('Password', this.newPassword));
            if (this.passwordformatValidation.passwordReqOneLowercase) this.errors.push(ValidateField.lowerCaseCharacterRequired('Password', this.newPassword));
            if (this.passwordformatValidation.passwordReqOneNumber) this.errors.push(ValidateField.numericRequired('Password', this.newPassword));
            if (this.passwordformatValidation.passwordReqOneSpecialChar) this.errors.push(ValidateField.specialCharacterRequired('Password', this.newPassword));
            this.errors.push(ValidateField.charMinAndMax('Password', this.newPassword, this.passwordformatValidation.minPasswordLength, 128));
        }else{
            this.errors.push(ValidateField.alphanumeric('Password', this.newPassword));
            this.errors.push(ValidateField.charMinAndMax('Password', this.newPassword, 6, 15));
        }
        this.errors.push(ValidateField.required('Password', this.newPassword));
        this.errors.push(ValidateField.matchData('Password', this.newPassword, this.newPasswordConfirmation));
        this.errors = this._.compact(this.errors);
        return this.errors.length;
      },
      checkPasswordDuration(){
        if(this.onPasswordExpiration){
          switch (this.passwordformatValidation.passExpDuration) {
            case '1w':
                return moment(new Date()).add(7,'days')
                break;
            case '1m':
                return moment(new Date()).add(1,'months')
                break;
            case '2m':
                return moment(new Date()).add(2,'months')
                break;
            case '3m':
                return moment(new Date()).add(3,'months')
                break;
            case '6m':
                return moment(new Date()).add(6,'months')
                break;
            case '1y':
                return moment(new Date()).add(12,'months')
                break;
            default:
                break;
          }
        }
      },
      async getAccountSettings(){
          let accountSetting = await this.getCachedAccountSettingsByCode()
          let settings = accountSetting ? [accountSetting] : []
          // bryan
          if(settings.length > 0){
              let AccountSettings = JSON.parse(settings[0].value)
              let sitePricingEnabled = AccountSettings.sitePricingEnabled
              let userBrandLevel = AccountSettings.userBrandLevel
              secureStorage.setItem("sitePricingEnabled", sitePricingEnabled)

              //If user brands is enabled, get user brands then save to sessions userId
              // thisselectedSiteId
              let selectedSiteId = this.selectedSiteId
              if(userBrandLevel){
                let userBrands = await HTTPRequest.getRequest(this.endPoint + 'users/show_user_site_brands/?user_id=' + secureStorage.getItem("userId") + '&site_id=' + selectedSiteId, '', null)
                secureStorage.setItem("userBrands", userBrands['brand_ids'])
                secureStorage.setItem("userBrandLevel", true)
                secureStorage.setItem("docUserSiteBrand", userBrands['doc_site_ids'])
                secureStorage.setItem("siteBrands", userBrands['site_brand_ids'])              
              } else{
                secureStorage.setItem("userBrandLevel", false)
              }
              // console.log("doc site brand" ,secureStoerage.getItem("docUserSiteBrand"))
              if(AccountSettings.userPasswordFormatStrict != undefined){
                this.userPasswordFormatStrict = AccountSettings.userPasswordFormatStrict
              }
              if (this.userPasswordFormatStrict){
                if(AccountSettings.minPasswordLength!=undefined){
                    this.passwordformatValidation.minPasswordLength = AccountSettings.minPasswordLength
                } else {
                    this.passwordformatValidation.minPasswordLength = 6
                }
                if(AccountSettings.passwordReqOneUppercase!=undefined){
                    this.passwordformatValidation.passwordReqOneUppercase = AccountSettings.passwordReqOneUppercase
                }
                if(AccountSettings.passwordReqOneLowercase!=undefined){
                    this.passwordformatValidation.passwordReqOneLowercase = AccountSettings.passwordReqOneLowercase
                }
                if(AccountSettings.passwordReqOneNumber!=undefined){
                    this.passwordformatValidation.passwordReqOneNumber = AccountSettings.passwordReqOneNumber
                }
                if(AccountSettings.passwordReqOneSpecialChar!=undefined){
                    this.passwordformatValidation.passwordReqOneSpecialChar = AccountSettings.passwordReqOneSpecialChar
                }
                if(AccountSettings.onPasswordExpiration!=undefined){
                    this.onPasswordExpiration = AccountSettings.onPasswordExpiration
                    if(AccountSettings.passExpDuration!=undefined){
                        this.passwordformatValidation.passExpDuration = AccountSettings.passExpDuration
                    }
                }
              }
              // console.log(AccountSettings[0].value.userPasswordFormatStrict,AccountSettings[0].value[:userPasswordFormatStrict])
              // if(AccountSettings[0].value.userPasswordFormatStrict!=null){
              // }
          }
      },
      // bryan
      forceRerender() {
      this.componentKey += 1;
      }
    }
  };
</script>

<style lang="css">
.ant-upload-list-picture-card .ant-upload-list-item-error {
    border-color: #CAD1D7;
}

#modal-2___BV_modal_outer_ {
  z-index: 1 !important;
}
</style>
